import script from "./SelectableSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectableSearch.vue?vue&type=script&setup=true&lang=js"

import "./SelectableSearch.vue?vue&type=style&index=0&id=3816d75b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3816d75b"]])

export default __exports__